import styled from '@emotion/styled';
import get from 'lodash/get';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import { navigationService } from 'src/config/rootService';
import { Button } from 'src/shared/components/Button';
import { color, font } from 'src/shared/styles/variables';

import image from 'src/public/img/already_working_with_therapist.svg';

const Wrapper = styled.div({
    minHeight: '100vh',
    padding: 20,
    backgroundColor: color.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

const HeadingText = styled.h2(
    {
        color: color.pickledBluewood,
        textAlign: 'center',
        margin: '30px 0 20px',
    },
    font.black(font.size.headerExtended),
);

const DescriptionText = styled.p(
    {
        color: color.blueBayoux,
        maxWidth: 650,
        marginBottom: 40,
        textAlign: 'center',
        lineHeight: '28px',
    },
    font.book(font.size.medium),
);

const ButtonWrapper = styled.div({
    maxWidth: 330,
    width: '100%',
});

const QuestionsText = styled.span({
    color: color.royalBlue,
    marginTop: 25,
    cursor: 'pointer',
    ...font.heavy(font.size.basePlus),
});

enum AlreadyWorkingWithTherapistPageTestID {
    GotItButton = 'AlreadyWorkingWithTherapistPageTestID.GotItButton',
}

const AlreadyWorkingWithTherapistPage: React.FC<RouteComponentProps> = ({ location }) => {
    const nextPage = get(location, 'state.nextPage') || '';

    const { t } = useTranslation();

    return (
        <Wrapper>
            <img src={image} />

            <HeadingText>{t('onboarding:already_working_with_a_therapist_page.title')}</HeadingText>
            <DescriptionText>
                {t('onboarding:already_working_with_a_therapist_page.first_description')}
            </DescriptionText>
            <DescriptionText>
                {t('onboarding:already_working_with_a_therapist_page.second_description')}
            </DescriptionText>
            <ButtonWrapper>
                <Button
                    onClick={() => navigationService.navigate(nextPage)}
                    type="accept"
                    fullWidth
                    testID={AlreadyWorkingWithTherapistPageTestID.GotItButton}
                >
                    {t('onboarding:already_working_with_a_therapist_page.got_it')}
                </Button>
            </ButtonWrapper>
            <QuestionsText onClick={() => window.open('mailto:onboarding@joinmodernhealth.com')}>
                {t('onboarding:already_working_with_a_therapist_page.questions')}
            </QuestionsText>
        </Wrapper>
    );
};

export default AlreadyWorkingWithTherapistPage;
